import { SortDescriptor } from '@progress/kendo-data-query';
import { Alignment, ColumnsConfig, TableConfig } from 'shared/components/table/table.interfaces';
import { getPageable, getPagination } from 'shared/models/pagination.model';
import { InformationalWebLabels } from '../../informational-posting-web.utils';

export const infoPostingSort: Array<SortDescriptor> = [
  {
    field: 'datetimePostingEffective',
    dir: 'desc',
  },
];

export const postingTableConfig: TableConfig = {
  ...new TableConfig(),
  id: 'posting-Table',
  errorPanelConfig: {
    displayErrorPanel: true,
    errorPanelMainMessage: 'Looks like there are no Data.',
    errorPanelSubMessage:
      'There are currently no Data that match the selected criteria. Please refine your criteria and try again.',
  },
  resizable: true,
  reorderable: true,
  clickable: true,
  pageOffset: 1,
  pageable: getPageable(),
  pagination: getPagination(),
  sortable: {
    mode: 'single',
  },
  sort: infoPostingSort,
  persistPreviousSort: false,
  alternatingRowStyle: true,
  height: 760,
  showTotal: true,
  scrollable: 'scrollable',
  allowColumnHeaderWrap: true,
};
export const postingColumnConfig: ColumnsConfig = {
  0: {
    headers: ['Description'],
    dataFields: [InformationalWebLabels.DESCRIPTIONDATAFIELD],
    width: 80
  },
  1: {
    headers: ['Date/Time Posting Effective'],
    dataFields: [InformationalWebLabels.DATETIMEDATAFIELD],
    width: 80,
  },
  2: {
    headers: ['Download'],
    dataFields: [InformationalWebLabels.ACTIONSDATAFIELD],
    width: 100,
    isSortable: [false]
  },
};

export interface InfopostWebsitePostingsDataList { }
